import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { MarketplaceTeammate } from '@app/shared/interfaces/lib/task.interface';
import { UiModule } from '@app/ui';
import { ButtonComponent, DividerDotComponent, PluralizePipe } from '@ui';
import { TimeAgoPipe } from '@utils/pipes';

@Component({
  selector: 'sbnb-cleaner-card',
  standalone: true,
  imports: [CommonModule, DividerDotComponent, UiModule, ButtonComponent, TimeAgoPipe, PluralizePipe],
  templateUrl: './cleaner-card.component.html',
})
export class CleanerCardComponent {
  cleaner = input.required<MarketplaceTeammate>();

  // Optional inputs for different display modes
  showMessageButton = input<boolean>(false);
  unreadMessagesCount = input<number>(0);
  hasMessages = input<boolean>(false);

  // Output for message button click
  messageClick = output<void>();

  onMessageClick(): void {
    this.messageClick.emit();
  }
}
